export default __webpack_public_path__ + "static/media/blue-lines-bg-top.5aa8d3d4.png";